import React, {Component} from "react"
import Spinner from "./Spinner"

class Button extends Component {
  render() {
    const className = this.props.className || ''
    const loading = this.props.loading
    const disabled = this.props.disabled || loading

    const style = this.props.style || 'primary'

    return (
      <div
        onClick={(e)=>{

          if(!disabled){
            if(_.isFunction(this.props.onClick)){
              this.props.onClick(e)
            }
          }else{
            e.stopPropagation()
          }
        }}
        className={`${className} btn btn-${style} ${disabled?'disabled':''}`}>
        {loading?
          <Spinner show={loading}/>
          :
          this.props.children}
      </div>
    )
  }
}

export default Button



// WEBPACK FOOTER //
// ./src/components/Button.js